import { render, staticRenderFns } from "./BlockMedia.vue?vue&type=template&id=4e5ab496"
import script from "./BlockMedia.vue?vue&type=script&lang=js"
export * from "./BlockMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports